import { getRouteType } from '../../components/3catinfo/Enllac/RouteResolver';
import { useRouter } from 'next/router';
import { createContext, useState, useEffect, useMemo, useRef } from 'react';

export const LoadingContext = createContext();

const LoadingProvider = (props) => {
    const { children } = props;

    const [activeLoading, setActiveLoading] = useState({ active: false, msg: false });
    const [skeletonLoading, setSkeletonLoading] = useState(false);
    const router = useRouter();

    const scrollPositions = useRef({});
    const isBackNavigation = useRef(false);

    const handleRouteStartScroll = () => {
        if (!isBackNavigation.current) {
            scrollPositions.current[router.asPath] = {
                x: window.scrollX,
                y: window.scrollY
            };
        }
    };
    const handleRouteCompleteScroll = (url) => {
        setTimeout(() => {
            if (isBackNavigation.current) {
                const pos = scrollPositions.current[url];
                if (pos) {
                    setTimeout(() => {
                        window.scrollTo(pos.x, pos.y);
                    }, 50);
                }
            } else {
                window.scrollTo({ top: 0, behavior: 'auto' });
            }

            isBackNavigation.current = false;
        }, 0);
    };
    const setIsActiveLoading = (active, msg = false, style = false) => {
        setActiveLoading({ active, msg, style });
    };

    const handleRouteStart = (url) => {
        handleRouteStartScroll();
        url !== router.asPath && setSkeletonLoading(getRouteType(url));
    };
    const handleRouteComplete = (url) => {
        handleRouteCompleteScroll(url);
        if (url === router.asPath) {
            setTimeout(() => {
                setSkeletonLoading(false);
            }, 500);
        }
    };

    const value = useMemo(
        () => ({
            setIsActiveLoading,
            activeLoading,
            skeletonLoading
        }),
        [setIsActiveLoading, activeLoading, skeletonLoading]
    );

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        router.beforePopState(() => {
            isBackNavigation.current = true;
            return true;
        });

        router.events.on('routeChangeStart', handleRouteStart);
        router.events.on('routeChangeComplete', handleRouteComplete);
        router.events.on('routeChangeError', handleRouteComplete);
        return () => {
            router.events.off('routeChangeStart', handleRouteStart);
            router.events.off('routeChangeComplete', handleRouteComplete);
            router.events.off('routeChangeError', handleRouteComplete);
        };
    });

    return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};

export default LoadingProvider;
